export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/uploaded.d397b478.svg","height":23,"width":22,"blurWidth":0,"blurHeight":0};